
export default {
  namespaced: true,//开启命名空间
  state: {
    topic: sessionStorage.getItem('topic') || 'defaults',
    //搜索框数据
    searchVal: '',
    //tabar选中
    tabarIndex: Number(sessionStorage.getItem('tabarIndex') || 0),
    //投票总票数（方便投票后实时修改票数）
    zvoteNumber: 0,
    //活动访问量
    zClick: 0,
    //rank选组
    groupName: 0,
    //vote选组
    voteGroupName: null,
    //已选中选手
    choosePlayersList: [],
    //分组数据
    groupsList: null,
    //提示的组ID
    tipID: {
      fid: null,
      id: null
    },
    //后台无边框广告
    noborderWord: null,
    // 投票广告顶部
    voteAd: "",
    // 投票广告中间
    // 投票广告底部
    //postinfo
    postinfo: {
      userimg: null,
      no: null,
      name: null,
    }
  },
  mutations: {
    changeValue(state, val) {
      val.forEach((item, i) => {
        state[item.name] = item.value
      });
    },
    // 投票广告
    giveVoteAd(state, val) {
      state.voteAd = val
    },
    //保存选手
    getChoosePlayersList(state, val) {
      let res = state.choosePlayersList.find(item => item.id == val.id)
      if (!res) {
        state.choosePlayersList.push(val)
      } else {
        state.choosePlayersList.some((item, i) => {
          if (item.id == res.id) {
            state.choosePlayersList.splice(i, 1)
            return true
          }
        })
      }
    },
  },
  actions: {

  },
  getters: {

  }
}
